module.exports = __webpack_public_path__ + "img/pen.cccc6df0.svg";